import * as React from 'react';

import { Button, Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { getQuestCheckConnectionText, getQuestLoadErrorText } from '../custom-text';

const ReloadButton = Button.withConfig({
  variant: 'outline',
  borderColor: getDesignToken('border-color-error'),
  _text: {
    variant: 'copyTwo',
    fontSize: 'sm',
    color: getDesignToken('text-error'),
  },
});

export const QuestDetailError = ({ refetch }: { refetch: () => void }) => {
  const errorHeaderMessage = getQuestLoadErrorText();

  useLogUserErrorMessage({
    message: errorHeaderMessage,
    severity: LogUserErrorSeverity.GeneralError,
    context: {
      moreInfo: 'quest-detail-error.tsx',
    },
  });

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.message}>
        <Typography variant="headerTwo" textAlign="center">
          {errorHeaderMessage}
        </Typography>
        <Typography textAlign="center">{getQuestCheckConnectionText()}</Typography>
      </Box>
      <Box style={styles.button}>
        <ReloadButton
          leftIcon={
            <Icon variant="refresh" size="sm" color={getDesignToken('border-color-error')} />
          }
          onPress={refetch}
        >
          {t('tryAgain')}
        </ReloadButton>
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  wrapper: { alignItems: 'center', flex: 1, gap: 24, justifyContent: 'center', padding: 16 },
  message: { alignItems: 'center' },
  button: { flexShrink: 1 },
});
